import React, { useState, useEffect } from 'react';
import PageHeader from '../components/PageHeader';
import AnimatedSection from '../components/AnimatedSection';
import { FaMapMarkedAlt, FaTicketAlt, FaRoute, FaUsers } from 'react-icons/fa';

// Data ini dapat dipindahkan ke Firestore untuk kontrol dinamis penuh
const careerProspects = [
    { icon: <FaMapMarkedAlt />, title: 'Pemandu Wisata (Tour Guide)' },
    { icon: <FaTicketAlt />, title: 'Staf Ticketing & Reservasi' },
    { icon: <FaRoute />, title: 'Perencana Tur (Tour Planner)' },
    { icon: <FaUsers />, title: 'Staf MICE' }, // MICE: Meeting, Incentive, Convention, and Exhibition
];

const PariwisataPage = () => {
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchActivities = async () => {
        setLoading(true);
        try {
            // TODO: Ganti dengan fetch dari Firestore
            // const q = query(collection(db, "activities"), where("major", "==", "pariwisata"));
            // const querySnapshot = await getDocs(q);
            // const activitiesData = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            // setActivities(activitiesData);

            // Mensimulasikan pengambilan data dengan data statis
            const staticActivities = [
              { id: 1, title: 'Praktik Pemanduan Wisata (Guiding)', description: 'Siswa mempraktikkan teknik pemanduan wisata di destinasi populer seperti Kota Tua dan Monumen Nasional, melatih kemampuan komunikasi dan pengetahuan sejarah.', image: 'https://images.unsplash.com/photo-1543269865-cbf427effbad?q=80&w=2070' },
              { id: 2, title: 'Simulasi Ticketing & Reservasi', description: 'Di laboratorium komputer, siswa menggunakan sistem reservasi (Amadeus/Galileo) untuk simulasi pemesanan tiket pesawat dan hotel, sesuai standar industri.', image: 'https://images.unsplash.com/photo-1521791136064-7986c2920216?q=80&w=2070' },
              { id: 3, title: 'Perencanaan Paket Tur', description: 'Siswa belajar merancang dan menghitung biaya paket wisata, mulai dari itinerary, akomodasi, hingga transportasi, untuk berbagai segmen pasar.', image: 'https://images.unsplash.com/photo-1508672019048-805c876b67e2?q=80&w=2070' },
            ];
            setActivities(staticActivities);

        } catch (error) {
            console.error("Error fetching activities: ", error);
        } finally {
            setLoading(false);
        }
    };

    fetchActivities();
  }, []);

  return (
    <>
      <PageHeader 
        title="Jurusan Pariwisata" 
        subtitle="Membentuk Generasi Muda yang Siap Mengembangkan Industri Pariwisata Indonesia" 
      />

      {/* Prospek Karir */}
            <AnimatedSection>
        <section className="section career-prospects-section">
            <div className="container">
                <h2>Prospek Karir Lulusan</h2>
                <p className="page-intro-text">
                    Lulusan jurusan Usaha Perjalanan Wisata memiliki prospek cerah di berbagai sektor industri pariwisata, mulai dari biro perjalanan hingga event organizer.
                </p>
                <div className="prospects-grid">
                    {careerProspects.map((prospect, index) => (
                        <div key={index} className="prospect-card">
                            <div className="prospect-icon">{prospect.icon}</div>
                            <h3>{prospect.title}</h3>
                        </div>
                    ))}
                </div>
            </div>
        </section>
      </AnimatedSection>
      
      {/* Galeri Kegiatan Pariwisata */}
      <AnimatedSection>
        <section className="section">
          <div className="container">
            <h2>Galeri Kegiatan Pariwisata</h2>
            <p className="page-intro-text">
              Jurusan Usaha Perjalanan Wisata (UPW) membekali siswa dengan keterampilan praktis untuk mengelola perjalanan dari A hingga Z. Lihatlah beberapa kegiatan utama kami.
            </p>
            {loading ? (
              <p style={{textAlign: 'center'}}>Memuat kegiatan...</p>
            ) : (
              <div className="activity-grid">
                {activities.map((activity) => (
                  <div key={activity.id} className="activity-card">
                    <img src={activity.image} alt={activity.title} className="activity-image" />
                    <h3 className="activity-title">{activity.title}</h3>
                    <p className="activity-description">{activity.description}</p>
                  </div>
                ))}
              </div>
            )}
          </div>
        </section>
      </AnimatedSection>

      {/* Mengapa memilih jurusan pariwisata */}
      <AnimatedSection>
        <section className="section">
          <div className="container">
            <h2>Mengapa Memilih Jurusan Pariwisata?</h2>
            <div className="why-choose-us-grid">
              <div className="why-choose-us-item">
                <h3>Kurikulum Berbasis Industri</h3>
                <p>Materi pembelajaran kami dirancang sesuai dengan kebutuhan industri pariwisata terkini, memastikan lulusan siap kerja.</p>
              </div>
              <div className="why-choose-us-item">
                <h3>Praktik Langsung & Kunjungan Lapangan</h3>
                <p>Siswa mendapatkan pengalaman nyata melalui praktik di laboratorium simulasi dan kunjungan langsung ke destinasi wisata serta biro perjalanan.</p>
              </div>
              <div className="why-choose-us-item">
                <h3>Pengajar Berpengalaman</h3>
                <p>Dibimbing oleh guru-guru profesional yang memiliki pengalaman luas di bidang pariwisata.</p>
              </div>
              <div className="why-choose-us-item">
                <h3>Peluang Magang & Karir Luas</h3>
                <p>Kami menjalin kerja sama dengan berbagai perusahaan pariwisata untuk memberikan kesempatan magang dan prospek karir yang cerah bagi lulusan.</p>
              </div>
            </div>
          </div>
        </section>
      </AnimatedSection>

    </>
  );
};

export default PariwisataPage;